module.exports = __webpack_public_path__ + "static/img/partner-hrxh.f910702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-hrxh.png
// module id = z9+t
// module chunks = 34